import { RootState } from '../../store';

export const getRoleSelector = (state: RootState) => state?.roleReducer?.role;
